module.exports = __webpack_public_path__ + "static/img/p2.446c3301.png";